import { Box } from '@mui/material';
import { AppLogo, Signup, ThemeToggle } from 'components';

export const PublicSignup = () => {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2, gap: 2 }}>
            <Box sx={{ position: 'fixed', top: 8, right: 8 }}>
                <ThemeToggle />
            </Box>
            <div className="login-header">
                <AppLogo fontSize="1.5em" />
            </div>
            <Signup />
        </Box>
    );
};
